import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import './component.scss';
import {API} from 'src/api';
import Cleave from 'cleave.js';
import {addClass, removeClass, find, findAll, displayElement, hideElement} from '@fretadao/f-js-dom';

// FIXME / TO DO
// This controller relies TOO much on hardcoded id/classes to work.
// We should refactor it when we update to Stimulus 2.0 using the
// Classes API
application.register(
  'boarding-authorization',
  class extends Controller {
    static targets = [
      'direction',
      'lineId',
      'cpf',
      'boardingAt',
      'originIngoing',
      'originAllIngoing',
      'destinationIngoing',
      'destinationAllIngoing',
      'originOutgoing',
      'originAllOutgoing',
      'destinationOutgoing',
      'destinationAllOutgoing',
      'departureIdIngoing',
      'departureIdOutgoing',
      'arrivalIdIngoing',
      'arrivalIdOutgoing',
    ];
    screens = [];

    connect() {
      this.addInputMasks();
      this.showCorrectDepartureArrival();
    }

    directionInput(event) {
      event.currentTarget.value == 'Ida'
        ? (this.directionTarget.value = 'ingoing')
        : (this.directionTarget.value = 'outgoing');

      this.showCorrectDepartureArrival();
    }

    showCorrectDepartureArrival() {
      if (this.hasDirectionTarget) {
        // if lines#show page does not allow for boarding authorizations, the following code gives an error due
        // to directionTarget be missing
        if (this.directionTarget.value == 'ingoing') {
          hideElement(find('.outgoing-routes-departure'));
          hideElement(find('.outgoing-routes-arrival'));
          displayElement(find('.ingoing-routes-departure'));
          displayElement(find('.ingoing-routes-arrival'));
        } else {
          hideElement(find('.ingoing-routes-departure'));
          hideElement(find('.ingoing-routes-arrival'));
          displayElement(find('.outgoing-routes-departure'));
          displayElement(find('.outgoing-routes-arrival'));
        }
      }
    }

    createBoardingAuthorization() {
      this.clearErrors();

      let cpf = this.cpfTarget.value.replace(/[\.\-]/g, '');
      let date = this.boardingAtTarget.value;
      let inputsAreValid = this.validateInputs(cpf, date);

      if (!inputsAreValid) return;

      let origin = '';
      let originAll = '';
      let destination = '';
      let destinationAll = '';
      let arrival_id = '';
      let departure_id = '';

      if (this.directionTarget.value == 'ingoing') {
        origin = this.originIngoingTarget.value;
        originAll = this.originAllIngoingTarget.value;
        destination = this.destinationIngoingTarget.value;
        destinationAll = this.destinationAllIngoingTarget.value;
        arrival_id = this.arrivalIdIngoingTarget.value;
        departure_id = this.departureIdIngoingTarget.value;
      } else {
        origin = this.originOutgoingTarget.value;
        originAll = this.originAllOutgoingTarget.value;
        destination = this.destinationOutgoingTarget.value;
        destinationAll = this.destinationAllOutgoingTarget.value;
        arrival_id = this.arrivalIdOutgoingTarget.value;
        departure_id = this.departureIdOutgoingTarget.value;
      }

      this.screens.push(find('#boarding-authorization'));
      let that = this;

      API.boardingAuthorization
        .create({
          cpf: cpf,
          boarding_at: date,
          line_id: this.lineIdTarget.value,
          departure_route_id: departure_id,
          arrival_route_id: arrival_id,
          origin_address: origin,
          origin_address_ll: originAll,
          destination_address: destination,
          destination_address_ll: destinationAll,
          direction: this.directionTarget.value,
        })
        .then(response => {
          let resultScreen = document.createElement('div');
          resultScreen.innerHTML = response.data;
          that.screens.push(resultScreen);
          that.renderTopScreen();
        });
    }

    validateInputs(cpf, date) {
      let isValid = true;
      if (cpf.length !== 11) {
        this.highlightErrorField('cpf');
        isValid = false;
      }

      let dateIsValid = moment(date, 'DD/MM/YYYY', true).isValid();
      if (!dateIsValid) {
        this.highlightErrorField('date');
        isValid = false;
      }

      return isValid;
    }

    renderTopScreen() {
      let currentScreen = this.screens[this.screens.length - 1];
      this.element.innerHTML = '';
      this.element.appendChild(currentScreen);
    }

    highlightErrorField(fieldName) {
      displayElement(document.getElementById(`${fieldName}-alarm`));
      let inputField = document.getElementById(`${fieldName}-input`);
      addClass(inputField, 'boarding-authorization-form--highlight-error');
    }

    clearErrors() {
      findAll('.boarding-authorization-form__input-alarm-error', this.element).forEach(errorMessage => {
        hideElement(errorMessage);
      });

      findAll('input', this.element).forEach(input => {
        removeClass(input, 'boarding-authorization-form--highlight-error');
      });
    }

    onScroll() {
      let boardingAuthorizationCard = find('#boarding-authorization');
      let responsiveBottomBar = find('.responsive-contact-button');
      if (!boardingAuthorizationCard || !responsiveBottomBar) return;

      if (this.isVisibleOnScreen(boardingAuthorizationCard)) {
        hideElement(responsiveBottomBar);
      } else {
        displayElement(responsiveBottomBar);
      }
    }

    isVisibleOnScreen(element) {
      var rect = element.getBoundingClientRect();
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    addInputMasks() {
      if (find('#cpf-input')) {
        new Cleave('#cpf-input', {blocks: [3, 3, 3, 2], numericOnly: true, delimiters: ['.', '.', '-']});
      }
      if (find('#date-input')) {
        new Cleave('#date-input', {date: true, delimiter: '/', datePattern: ['d', 'm', 'Y']});
      }
    }

    back() {
      this.screens.pop();
      this.renderTopScreen();
      this.addInputMasks();
    }
  }
);
